<template>
  <div id="containt" class="index-home-sys">
    <i class="iconfont icon-a-kaifa1"></i>
    <span>{{$t1('开发管理平台')}}</span>
  </div>
</template>

<script>

export default {
  data() {
    return {
    }
  },
  methods: {
  }

};
</script>
<style scoped lang="scss">
.index-home-sys{
  background-color: #DEE9F2 !important;margin-top: 10px !important;height: calc(100vh - 52px);border-radius: 12px !important;text-align: center;line-height: calc(100vh - 60px);letter-spacing: 2px;
  font-size: 48px;font-weight: 600;
  i{vertical-align: middle;font-weight: 400;margin-right: 24px;color:#225076;font-size:48px;}
  span{position: relative;
    &:before{content: "";position: absolute;bottom:0;left:0;width: 223px;height: 16px;background: #96B4CD;z-index: -1;opacity: 0.8;}
  }
}
</style>
